import {
  Button,
  CircularProgress,
  createStyles,
  makeStyles,
  Theme
} from '@material-ui/core';
import React, {useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {APP, GET_8_PIXEL_BOX, DEFAULT_WHITE_COLOR} from 'src/style/variable';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import {useSelector} from 'react-redux';
import {cancelCardMachineTransaction} from '@shared/services/PaymentProvider.service';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    reactLoaderDialogPage: {
      height: 'inherit'
    },
    reactLoader: {
      height: 'inherit',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      justifyContent: 'center'
    },
    reactLoaderText: {
      fontWeight: 600,
      fontSize: '20px',
      margin: '2rem 0 0 0',
      textAlign: 'center'
    },
    verifyLoaderText: {
      maxWidth: '500px',
      fontWeight: 600,
      fontSize: '15px',
      margin: '2rem 0 0 0',
      textAlignLast: 'center'
    },
    reactLoaderComponent: {
      width: '100px !important',
      height: '100px !important'
    },
    cancelButton: {
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '3.5rem',
      width: '8rem',
      marginTop: '5rem',
      color: DEFAULT_WHITE_COLOR
    }
  })
);

// TODO: Give proper types to the below interface
interface ReactLoaderProps {
  cardMachineDetailsObject?: any;
  cardMachineDetails?: any;
  setReactLoaderComponent?: any;
  verifyCardMachineDialogContent?: any;
  cancelVerifyApi?: any;
  setCardMachineDetails?: any;
  setPracticeMachinesList?: any;
  setLoader?: any;
}

const ReactLoader = (props: ReactLoaderProps): React.ReactElement => {
  const {enqueueSnackbar} = useSnackbar();

  const {t} = useTranslation();
  const classes = useStyles();
  const cardMachinePayment: any = useSelector(
    (state: any) => state.cardMachine.cardMachineReferenceId || null
  );

  const {
    cardMachineDetailsObject,
    cardMachineDetails,
    setReactLoaderComponent,
    verifyCardMachineDialogContent,
    cancelVerifyApi,
    setCardMachineDetails,
    setPracticeMachinesList,
    setLoader
  } = props;
  const [
    cancelCardMachinePayment,
    setCancelCardMachinePayment
  ] = useState<boolean>(false);

  const cancelCardMachineTransactionPayment = (data: any) => {
    if (cardMachinePayment?.cardMachineReferenceId !== null) {
      cancelCardMachineTransaction({
        clinic_group_id: data?.clinic_group_id,
        clinic_id: data?.clinic_id,
        body: {
          ...data,
          terminal_id: data?.terminal_id,
          reference_id: cardMachinePayment?.cardMachineReferenceId
        }
      })
        .then(res => {
          setReactLoaderComponent(false);
          setCancelCardMachinePayment(false);
          setCardMachineDetails(false);
          setPracticeMachinesList(true);
          setLoader(false);
          enqueueSnackbar(res?.message, SnackBarConfig('s'));
        })
        .catch((error: any) => {
          setCancelCardMachinePayment(false);
          enqueueSnackbar(
            (error && error.message) ||
              t('PAYMENTS_LOGIN.TRANSACTION_NOT_INITIATED'),
            SnackBarConfig('e')
          );
          setReactLoaderComponent(true);
        });
    }
  };
  return (
    <div className={classes.reactLoaderDialogPage}>
      <div className={classes.reactLoader}>
        <CircularProgress
          className={classes.reactLoaderComponent}
          thickness={5}
          value={5}
          size={40}
        />
        {verifyCardMachineDialogContent && (
          <div className={classes.verifyLoaderText}>
            {t('CLINICS.CARD_MACHINES_TABLE.CARD_MACHINE_LOADER_CONTENT')}
          </div>
        )}

        {cardMachineDetails && (
          <div className={classes.reactLoaderText}>
            {t('PAYMENTS_LOGIN.CARD_MACHINE_WAITING')}
          </div>
        )}
        {cardMachineDetails && (
          <Button
            fullWidth
            variant="contained"
            size={'medium'}
            color="primary"
            className={[classes.cancelButton].join(' ')}
            type={'submit'}
            onClick={() => setCancelCardMachinePayment(true)}>
            {t('INSTALLMENTS.CANCEL')}
          </Button>
        )}

        {verifyCardMachineDialogContent && (
          <Button
            fullWidth
            variant="contained"
            size={'medium'}
            color="primary"
            className={[classes.cancelButton].join(' ')}
            type={'submit'}
            onClick={cancelVerifyApi}>
            {t('INSTALLMENTS.CANCEL')}
          </Button>
        )}
      </div>
      {cancelCardMachinePayment && (
        <ConfirmationDialog
          open={cancelCardMachinePayment}
          title={t('INSTALLMENTS.CANCEL_CARD_MACHINE_TRANSACTION')}
          description={
            <Trans
              i18nKey={'INSTALLMENTS.DELETE_TRANSCATION'}
              values={{
                machineName: cardMachineDetailsObject?.machine_name
              }}
              components={[<strong key={'X'} />]}
            />
          }
          confirmButtonText={t('INSTALLMENTS.YES')}
          cancelButtonText={t('INSTALLMENTS.NO')}
          onClose={response => {
            if (response === 'confirm') {
              setCancelCardMachinePayment(true);
              cancelCardMachineTransactionPayment(cardMachineDetailsObject);
            } else {
              setCancelCardMachinePayment(false);
            }
          }}
        />
      )}
    </div>
  );
};

export default ReactLoader;
